import React from 'react';

import type { Referral, ReferralKey, ReferralSenderOfferName, SenderOfferFulfillment } from '../data';

type Props = ReferralSenderOfferName & {
  referralKey: string;
  senderOfferFulfillments: SenderOfferFulfillment[];
  hasMaximumInvestingReferrals: boolean;
  referralInvites: Referral[];
  referralFulfillments: number;
  maxReferralRewardCount: number;
};

export const ReferralSenderOfferContext = React.createContext<Props | null>(null);
export const ReferralKeyContext = React.createContext<ReferralKey | null>(null);

export const ReferAFriendProvider: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  referralKey,
  senderOfferName,
  senderOfferFulfillments,
  hasMaximumInvestingReferrals,
  referralInvites,
  referralFulfillments,
  maxReferralRewardCount,
}) => {
  const senderValues = React.useMemo(
    () => ({
      senderOfferName,
      referralKey,
      senderOfferFulfillments,
      hasMaximumInvestingReferrals,
      referralInvites,
      referralFulfillments,
      maxReferralRewardCount,
    }),
    [
      senderOfferName,
      senderOfferFulfillments,
      referralKey,
      hasMaximumInvestingReferrals,
      referralInvites,
      referralFulfillments,
      maxReferralRewardCount,
    ]
  );
  const keyValues = React.useMemo(() => ({ referralKey }), [referralKey]);

  return (
    <ReferralSenderOfferContext.Provider value={senderValues}>
      <ReferralKeyContext.Provider value={keyValues}>{children}</ReferralKeyContext.Provider>
    </ReferralSenderOfferContext.Provider>
  );
};

export const useReferralSenderOffer = () => {
  const context = React.useContext(ReferralSenderOfferContext);
  if (!context) {
    throw new Error('useReferralSenderOffer must be used under ReferralSenderOfferProvider');
  }
  return context;
};

export const useReferralKey = () => {
  const context = React.useContext(ReferralKeyContext);
  if (!context) {
    throw new Error('useReferralKey must be used under ReferralKeyProvider');
  }
  return context;
};
